import React from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import SelectFilter, { SelectFilterOption } from './SelectFilter';

const userTypeOptions: SelectFilterOption[] = [
  { value: '', label: 'All' },
  { value: 'assessor', label: 'Assessor' },
  { value: 'content_owner', label: 'Content Owner' },
  { value: 'vendor_admin', label: 'Service Provider' },
  { value: 'tpn_admin', label: 'TPN Admin' },
];

export default function UserTypeFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={userTypeOptions} />;
}
